module.exports = "/pages/business/foodslabo/fv_points_1.png";